import React from 'react';
import styled from '@emotion/styled';
import { injectIntl } from 'react-intl';

import { messages } from './messages';
import {
  SimpleSignupContextProps,
  SimpleSignupProvider
} from './hook/use-simple-signup-state';
import { useUserInfo } from '../../hook';
import { SimpleSignupFormLoggedOut } from './simple-signup-form-view/view';
import {
  SimpleSignupNav,
  FormFooter
} from './simple-signup-form-view/component';
import {
  fontCharlieText,
  TABLET_BREAKPOINT
} from './simple-signup-form-view/styled';
function SimpleSignupScreen(props: SimpleSignupContextProps) {
  const userInfo = useUserInfo();

  return (
    <SimpleSignupProvider {...props} userInfo={userInfo}>
      <PageRoot>
        <SimpleSignupNav />
        <PageBody>
          <SimpleSignupFormLoggedOut />
        </PageBody>
        <FormFooter />
      </PageRoot>
    </SimpleSignupProvider>
  );
}

export const PageRoot = styled.div`
  font-family: ${fontCharlieText};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;

  @media (min-width: ${TABLET_BREAKPOINT}) {
    padding: 0;
  }
`;

export const PageBody = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (min-width: ${TABLET_BREAKPOINT}) {
    flex: 1;
    max-width: 1440px;
  }
`;

SimpleSignupScreen.messages = messages;
export default injectIntl(SimpleSignupScreen);
